module.exports = __webpack_public_path__ + "i18n/ru.adbd02b09d589b1b2f6aac282519f78f.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/ru.json
// module id = 1010
// module chunks = 60